<template>
  <!-- header-->
  <header class="main-header dark-header fs-header sticky">
    <div
      class="header-inner d-flex justify-content-between w-100 h-100 align-items-center"
    >
      <div class="logo-holder d-flex h-100 align-items-center">
        <router-link :to="{ name: 'Dashboard', params: $route.params }">
          <img src="../../assets/images/logos/PET_logo_feher.png" alt=""
        /></router-link>
        <div class="nav-button-wrap color-bg" @click="mobilMenu()">
          <div class="nav-button"><span></span><span></span><span></span></div>
        </div>
        <div class="nav-holder" :class="{ vismobmenu: mobileMenuActive }">
          <nav class="float-none">
            <ul>
              <li class="h-100">
                <a href="javascript:;" class="">
                  {{ $t(selectedCountry.ResourceKey) }}
                  <i class="fa fa-caret-down"></i
                ></a>
                <!--second level -->
                <ul>
                  <li
                    v-for="(country, index) in countriesWithAll"
                    :key="country.Id"
                    :class="{ active: activeIndex === index }"
                  >
                    <a
                      href="javascript:;"
                      @click="
                        SetSelectedCountry(country);
                        setActive(country, index);
                      "
                      v-scroll-to="{
                        el: '#wastemap',
                        onStart: function(element) {
                          // scrolling started
                          mobilMenu();
                        },
                      }"
                    >
                      {{ $t(country.ResourceKey) }}</a
                    >
                  </li>
                </ul>
                <!--second level end-->
              </li>
              <!-- <li class="h-100">
                <a
                  href="javascript:;"
                  class=""
                  v-scroll-to="{
                    el: '#sec2',
                    offset: -50,
                    onStart: function(element) {
                      mobilMenu();
                    },
                  }"
                  >{{ $t('ui_introduction') }}</a
                >
              </li>
              <li class="h-100">
                <a
                  href="javascript:;"
                  class=""
                  v-scroll-to="{
                    el: '#apps',
                    offset: -50,
                    onStart: function(element) {
                      mobilMenu();
                    },
                  }"
                  >{{ $t('ui_apps') }}</a
                >
              </li>
              <li class="h-100">
                <a
                  href="javascript:;"
                  class=""
                  v-scroll-to="{
                    el: '#fbvideo',
                    offset: -50,
                    onStart: function(element) {
                      mobilMenu();
                    },
                  }"
                  >{{ $t('ui_introtext') }}</a
                >
              </li> -->
              <li class="h-100">
                <a
                  href="javascript:;"
                  class=""
                  v-scroll-to="{
                    el: '#sec3',
                    offset: -50,
                    onStart: function(element) {
                      // scrolling started
                      mobilMenu();
                    },
                  }"
                  >{{ $t('ui_pollutedAre') }}</a
                >
              </li>
              <!-- <li class="h-100">
                <a href="javascript:;" class="">Rendezvények</a>
              </li> -->

              <li class="h-100">
                <a
                  href="javascript:;"
                  class=""
                  v-scroll-to="{
                    el: '#contact',
                    offset: -50,
                    onStart: function(element) {
                      // scrolling started
                      mobilMenu();
                    },
                  }"
                  >{{ $t('ui_contacts') }}</a
                >
              </li>

              <li class="h-100">
                <a href="javascript:;" @click="OpenTudnivalokModal">
                  {{ $t('ui_information') }}
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="d-flex justify-content-between h-100 align-items-center">
        <div class="d-inline-block header-osszegzes">
          <div class="d-inline-block mr-sm-3 mr-md-3 mr-2">
            <span class="font-size-24 font-weight-bold">
              <k-animated-number :value="counter.cleaned"></k-animated-number>
            </span>
            <span class="font-size-24 pl-1">|</span>
            <span class="d-md-none d-sm-none d-lg-inline-block d-none">{{
              $t('ui_cleanedReport')
            }}</span>
            <span class="d-md-inline-block d-sm-inline-block d-lg-none"
              ><i class="fas fa-hand-sparkles"></i
            ></span>
          </div>
          <div class="d-inline-block ">
            <span class="font-size-24 font-weight-bold">
              <k-animated-number :value="counter.reported"></k-animated-number>
            </span>
            <span class="font-size-24 pl-1">|</span>
            <span class="d-md-none d-sm-none d-lg-inline-block d-none">{{
              $t('ui_reportedGarbagePile')
            }}</span>
            <span class="d-md-inline-block d-sm-inline-block d-lg-none"
              ><i class="fas fa-trash-restore"></i
            ></span>
          </div>
        </div>

        <!-- navigation  end -->
      </div>
      <div class="nav-holder" v-if="selectedlanguage">
        <nav>
          <ul>
            <li class="h-100 ml-0">
              <a href="javascript:;" class=""
                ><flag :iso="selectedlanguage.FlagISOCode"/>
                <i class="fa fa-caret-down"></i
              ></a>
              <!--second level -->
              <ul>
                <li v-for="language in languages" :key="language.Id">
                  <a href="javascript:;" @click="SetSelectedLanguage(language)"
                    ><flag :iso="language.FlagISOCode" />
                    <span class="d-md-inline-block ml-1">{{
                      language.DisplayLanguage
                    }}</span></a
                  >
                </li>
              </ul>
              <!--second level end-->
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';

import { apiService, eventBus } from '../../main';
import { NotificationFunctions } from '../../functions/notificationFunctions';
import { timeout } from '../../utils/common';
import { strCompare, boolCompare, sortStr } from '../../utils/sort';
import Multiselect from 'vue-multiselect';
import { CardPlugin } from 'bootstrap-vue';
import { AppStoreTypes } from '../../store/modules/app';
import { ka } from '../../utils/konalytics';
import { i18n } from '../../plugins/vuei18n';
import { BejegyzesStoreTypes } from '../../store/modules/bejegyzes';
import { Statuszok } from '../../data/enums/kodszotar/statuszok';
import { TisztaTiszaFunctions } from '../../functions/TisztaTiszaFunctions';

export default {
  name: 'dafault-header',
  data() {
    return { activeIndex: undefined, mobileMenuActive: false };
  },
  async mounted() {
    // if (!this.selectedIntezet && this.user) {
    //   this.SetSelectedIntezet({
    //     value: {
    //       ...this.user.RogzitoIntezet,
    //     },
    //   });
    // }
    this.activeIndex = 0;
  },
  created() {},
  computed: {
    ...mapGetters({
      languages: AppStoreTypes.languages.getAll,
      selectedCountry: AppStoreTypes.selectedCountry.get,
      countries: AppStoreTypes.countries.getAll,
      bejegyzesek: BejegyzesStoreTypes.bejegyzesek.getAll,
    }),
    countriesWithAll() {
      let countries2 = this.countries;
      function compare(a, b) {
        if (a.ResourceKey < b.ResourceKey) return -1;
        if (a.ResourceKey > b.ResourceKey) return 1;
        return 0;
      }

      return [
        ...countries2.sort(compare),
        {
          Id: -1,
          ResourceKey: 'ui_countryAll',
          Latitude: 47.3,
          Longitude: 21.2,
        },
      ];
    },
    counter() {
      let counter = {
        reported: 0,
        cleaned: 0,
      };
      let bejegyzesek = this.bejegyzesek;
      bejegyzesek.forEach(bejegyzes => {
        if (bejegyzes.Status == Statuszok.Cleaned) {
          counter.cleaned++;
        }
        counter.reported++;
      });
      return counter;
    },
    selectedlanguage() {
      return (
        this.languages.find(
          f => f.ISOCode == TisztaTiszaFunctions.GetLocale()
        ) || null
      );
    },
  },
  methods: {
    ...mapActions({}),
    mobilMenu() {
      this.mobileMenuActive = !this.mobileMenuActive;
    },
    async SetSelectedLanguage(value) {
      await timeout(50);
      if (value.ISOCode == TisztaTiszaFunctions.GetLocale()) {
        return;
      }

      this.$router.push(`/${value.ISOCode}/`);

      // Google maps miatt
      location.reload();

      // Reload miatt nem szükséges
      //this.$i18n.locale = value.ISOCode;
      //this.$meta().refresh();
    },
    setActive(country, index) {
      this.activeIndex = index;
    },
    async SetSelectedCountry(country) {
      await timeout(50);
      await this.$store.dispatch(AppStoreTypes.selectedCountry.set, {
        value: country,
      });
      let userSubscriptionKey = this.selectedCountry.Id;
      let indexOfObject = this.countriesWithAll.findIndex(
        o => o.Id === userSubscriptionKey
      );
      this.setActive(this.userSubscription, indexOfObject);
      this.mobileMenuActive = !this.mobileMenuActive;
      try {
        let garbagePlaces = await apiService.GetGarbagePlaces();
      } catch (error) {
        console.log(error);
        NotificationFunctions.ErrorAlert(
          this.$t('ui_alertErrorTitle'),
          this.$t('ui_alertErrorMessage')
        );
      }
    },
    OpenTudnivalokModal() {
      eventBus.$emit('Modal:terkep-info-modal');
    },
  },
  watch: {},
};
</script>
<style scoped>
a:hover {
  color: #fff;
  text-decoration: inherit;
}
.logo-holder {
  top: inherit;
}
.logo-holder a {
  top: inherit;
  height: 55px;
  display: flex;
  align-content: center;
  align-items: center;
}
.vis-header-search {
  float: right;
}
.header-separator:before {
  color: #fff;
  background: rgba(255, 255, 255, 0.21);
  content: '';
  position: absolute;
  top: 35%;
  right: -5px;
  height: 30px;
  width: 1px;
  margin-top: -15px;
}
.header-search-select-item {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 0 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.menu-panel {
  display: none !important;
}

.menusb .active + .menu-panel.show {
  display: block !important;
}
.menusb a i {
  transform: inherit !important;
}
.menusb .active > .fa.fa-caret-down:before {
  content: '\F0D8' !important;
}
.header-osszegzes {
  position: relative;
  color: white;
  font-size: 20px;
}
.nav-holder {
  top: inherit;
  margin-right: inherit;
  white-space: nowrap;
}
@media only screen and (min-width: 414px) {
  .header-osszegzes {
    white-space: nowrap;
  }
}
</style>
